<script>
import Cookies from "js-cookie";
import {notificationMethods, contentMethods} from "@/state/helpers";
import {required} from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor';
import appConfig from "@/app.config";
export default {
  page: {
    title: "Contents",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast,
    quillEditor,
  },
  data() {
    return {
      toastAction: '',
      toastMessage: '',
      showToast: false,
      itemsLoaded: false,
      items: [
      ],
      quillOptions: {
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            ['link'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['clean']
          ]
        }
      },
      kurlar: [
        {value: 'a1', label: 'A 1'},
        {value: 'a2', label: 'A 2'},
        {value: 'b1', label: 'B 1'},
        {value: 'b2', label: 'B 2 '},
        {value: 'c1', label: 'C 1'},
        {value: 'c2', label: 'C 2'},
      ],
      currentUser: JSON.parse(Cookies.get('user')),
      contents: [],
      title: "İçerİkler Tablosu",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Contents",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,
      noDeleteModal: false,
      formError: '',
      editFormError: '',
      courseData: [],
      rateData: [],
      addForm: {
        name: "",
        type: "",
        contentImage: "",
        videoUrl: "",
        file: "",
        kurs: "",
        kurlar: "",
        description: "",
        question: "", // Soru
        quizType: "", // Tip (Çoktan Seçmeli veya Text)
        correctAnswer: "", // Doğru Şık - Doğru Cevap
        prices: {},
        field: false,
      },
      editForm: {
        name: "",
        type: "",
        contentImage: "",
        videoUrl: "",
        file: "",
        kurs: "",
        kurlar: "",
        description: "",
        question: "", // Soru
        quizType: "", // Tip (Çoktan Seçmeli veya Text)
        correctAnswer: "", // Doğru Şık - Doğru Cevap
        prices: {},
        field: false,
      },
      ratePrices: {
        a1: 0,
        a2: 0,
        b1: 0,
        b2: 0,
        c1: 0,
        c2: 0,
      },
      editId: "",
      deleteId: "",
      totalRows: 1,
      page: 1,
      perPage: 10,
      search: '',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          label:'Başlık',
          sortable: true,
        },
        {
          key: "kurslar",
          label:'Kurs',
          sortable: true,
        },
        {
          key: "kurlar",
          label:'Kur',
          sortable: true,
        }, {
          key: "field",
          label:'Aktiflik Durumu',
          sortable: true,
        },
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      pageInput: 1
    };
  },
  created() {
    this.courseData = [
      { value: "ingilizce", label: "İngilizce Dil Eğitimi" },
      { value: "almanca", label: "Almanca Dil Eğitimi" },
      { value: "fransızca", label: "Fransızca Dil Eğitimi" },
    ];   this.rateData = [
      {"value": "a1", "label": "A 1", "order": "0", "price": "1000"},
      {"value": "a2", "label": "A 2", "order": "1", "price": "1000"},
      {"value": "b1", "label": "B 1", "order": "2", "price": "1000"},
      {"value": "b2", "label": "B 2" , "order": "3", "price": "1000"},
      {"value": "c1", "label": "C 1", "order": "4",  "price": "1000"},
      {"value": "c2", "label": "C 2", "order": "5",  "price": "1000"}
    ];
  },
  validations: {
    addForm: {
      rate: {required},
      rates: { required },
      course: {required},
      name: {required},
      type: {required},
      contentImage: {required},
      videoUrl: {required},
      file: {required},
      kurs: {required},
      kurlar: {required},
      description: {required},
      question: {required},
      quizType: {required},
      correctAnswer: {required},
      prices: {required},
      field:{required}
    },
    editForm: {
      rates: { required },
      rate: {required},
      course: {required},
      name: {required},
      type: {required},
      contentImage: {required},
      videoUrl: {required},
      file: {required},
      kurs: {required},
      kurlar: {required},
      description: {required},
      question: {required},
      quizType: {required},
      correctAnswer: {required},
      prices: {required},
      field:{required}
    },
  },
  computed: {
    rows() {
      return this.items.length;
    },
    courses() {
      return this.$store.getters.courses;
    },rates() {
      return this.$store.getters.rates;
    },
  },
  watch: {
    page(newPage) {
      this.pageInput = newPage;
      this.getContents(newPage);
    },
    search(newSearch) {
      if (newSearch.length < 1) {
        if (this.page === 1) {
          this.getContents();
        } else {
          this.page = 1;
        }
      }
    },
    'addForm.email': function () {
      this.addForm.email = this.turkishToLower(this.addForm.email)
    },
    'editForm.email': function () {
      this.editForm.email = this.turkishToLower(this.editForm.email)
    },
    'addForm.type': function (newType) {
      if (newType === 'quiz') {
        // Quiz tipi seçildiğinde formu göster
        this.showQuizForm = true;
      } else {
        // Diğer türler seçildiğinde formu gizle
        this.showQuizForm = false;
      }
    },
  },
  mounted() {
    this.getContents();
  },
  methods: {
    ...contentMethods,
    ...notificationMethods,
    updateImageUrl(url) {
      this.imageUrl = url;
    },
    onImageChange(e) {
      let files = e.target.files || e.data.transfer.files;
      if (!files.length)
        return;
      let data = new FormData()
      data.append('upload', files[0])
      data.append('folder', 'contents')
      let addForm = this.addForm;
      this.imgLoading = true;
      this.uploadFile(data).then((res) => {
        addForm.image = res.url;
        this.imgLoading = false;
      })
    },
    onEditImageChange(e) {
      let files = e.target.files || e.data.transfer.files;
      if (!files.length) return;

      let data = new FormData();
      data.append("upload", files[0]);
      data.append("folder", "contents");
      let editForm = this.editForm;
      this.editImgLoading = true;
      this.uploadFile(data)
          .then((res) => {
            editForm.image = res.url;
            this.imageUrl = res.url;
            this.editImgLoading = false;
          });
      this.$v.editForm.image.$touch();
    },
    formatInput(rate) {
      let number = this.addForm.prices[rate].replace(/[,.]/g, '');
      this.addForm.prices[rate] = parseFloat(number).toLocaleString('en-US');
    },
    doSearch() {
      if (this.page === 1) {
        this.getContents();
      } else {
        this.page = 1;
      }
    },
    handleFileUpload(event, form) {
      const selectedFile = event.target.files[0];

      if (selectedFile) {
        form.file = selectedFile;
      }
    },
    handleContentImageUpload(event, form) {
      const selectedFile = event.target.files[0];

      if (selectedFile) {
        form.contentImage = selectedFile;
      }
    },
    getContents(page = this.page) {
      this.itemsLoaded = false;
      let filter = {}
      if (this.filter) {
        filter.name = this.filter;
      }
      this.fetchContents({page, limit: this.perPage, search: this.search}).then(res => {
        this.totalRows = res.total;

        /*this.items = res.docs.map(elem=>{
          return elem;
        })*/
        this.items = res.map(item => {
          const kurlarLabels = item.kurlar.map(kurValue => {
            return kurValue.label
          }).join(', ');      const kurslarLabels = item.kurslar.map(kursValue => {
            return kursValue.label
          }).join(', ');
          return {
            ...item,
            kurlar: kurlarLabels,
            kurslar: kurslarLabels,
          };
        });
        this.itemsLoaded = true;
      })
    },
    handleSubmit() {
      this.addSubmitted = true;
      this.formError = "";
      this.$v.addForm.$touch();
      if (
          this.$v.addForm.$invalid
      ) {
        return;
      } else {
        this.addForm.description = this.$refs.quillEditor.quill.root.innerHTML;
        const field = this.addForm.field ? "true" : "false";
        const prices = {};
        for (const rate of this.addForm.rates) {
          prices[rate] = this.addForm.prices[rate];
        }
        this.createContent({
          ...this.addForm,
          prices:prices,
          kurs: this.addForm.kurs,
          kur: this.addForm.kur,
          rate: this.addForm.rate,
          course: this.addForm.course,
          field, // Checkbox alanı
        }).then(() => {
          this.toastMessage = "Content başarıyla eklendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.showModal = false;
          this.getContents();
          this.addForm.name = "";
          this.addForm.type = "";
          this.addForm.contentImage = "";
          this.addForm.videoUrl = "";
          this.addForm.file = "";
          this.addForm.kurs = "";
          this.addForm.kurlar = "";
          this.addForm.description = "";
          this.addForm.question = "";
          this.addForm.quizType = "";
          this.addForm.correctAnswer = false;
          this.addForm.rate = "";
          this.addForm.course = "";
        }).catch((err) => {
          if (err == 'TCNUMBER_ALREADY_USE') {
            this.formError = "Girilen TC numarasına sahip bir Content bulunmaktadır."
          } else {
            this.toastMessage = "Sistemde bir hata oluştu!";
            this.toastAction = "error";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000)
          }
        })
      }
    },
    handleEditSubmit() {
      this.editSubmitted = true;
      this.editFormError = ""
      this.$v.editForm.$touch();
      if (
          this.$v.editForm.$invalid
      ) {
        return;
      } else {
        const field = this.addForm.field ? "true" : "false";
        this.updateContent({
          id: this.editId,
          data: {
            ...this.editForm,
            field,
          },
        }).then(() => {
          this.toastMessage = "Content başarıyla düzenlendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.editModal = false;
          this.getContents();
        }).catch((err) => {
          if (err == 'TCNUMBER_ALREADY_USE') {
            this.editFormError = "Girilen TC numarasına sahip bir content bulunmaktadır."
          } else {
            this.toastMessage = "Sistemde bir hata oluştu!";
            this.toastAction = "error";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000)
          }
        })
      }
    },
    handleDeleteSubmit() {
      this.deleteContent(this.deleteId).then(() => {
        this.deleteModal = false;
        this.toastMessage = "Content başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getContents();
      })
    },
    openEdit(content) {
      this.editForm.rate = content.rate;
      this.editForm.course = content.course;
      this.editForm.name = content.name
      this.editForm.type = content.type
      this.editForm.contentImage = content.contentImage
      this.editForm.videoUrl = content.videoUrl;
      this.editForm.file = content.file
      this.editForm.kurs = content.kurs
      this.editForm.kurlar = content.kurlar
      this.editForm.description = content.description;
      this.editForm.field = content.field;
      this.editId = content.id;
      this.editForm.prices = content.prices;
      this.editModal = true;
    },
    openDelete(content) {
      if (content.email === this.currentUser.email) {
        this.noDeleteModal = true;
      } else {
        this.deleteId = content.id;
        this.deleteModal = true;
      }
    },
    turkishToLower(str) {
      let letters = {"İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç"};
      str = str.replace(/(([İIŞĞÜÇÖ]))+/g, function (letter) {
        return letters[letter];
      })
      return str.toLowerCase();
    }
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems"/>
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true"
                >
                  içerik ekle
                </button>
              </div>
            </div>
            <!-- Table -->
            <div v-if="itemsLoaded">
              <div class="table-responsive mb-0">
                <b-table
                    class="datatables"
                    :items="items"
                    :fields="fields"
                    responsive="sm"
                >
                  <template v-slot:cell(createdAt)="data">
                    {{ new Date(data.item.createdAt).toDateString() }}
                  </template>
                  <template v-slot:cell(siteler)="data">
                    <li v-for="site in data.item.siteler.split(',')" :key="site">{{ site }}</li>
                  </template>
                  <template v-slot:cell(kurlar)="data">
                        <span v-for="option in kurlar" :key="option.value">
                          <span
                              :value="option.value"
                          />
                          {{ option.label }},
                        </span>
                  </template>
                  <template v-slot:cell(kurslar)="data">
                  <li v-for="kurs in data.item.kurslar.split(',')" :key="kurs">{{ kurs }}</li>
                </template>
                  <template v-slot:cell(detail)="data">
                    <button
                        class="btn btn-info d-flex py-2"
                        @click="$router.push({name:'contentDetail',params:{contentId: data.item.id}})"
                    >
                      <i :class="`bx bxs-detail bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(edit)="data">
                    <button
                        class="btn btn-warning d-flex py-2"
                        @click="openEdit(data.item)"
                    >
                      <i :class="`bx bxs-edit bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(delete)="data">
                    <button
                        :disabled="currentUser.role.includes('user')"
                        class="btn btn-danger d-flex py-2"
                        @click="openDelete(data.item)"
                    >
                      <i :class="`bx bx-trash bx-xs`"></i>
                    </button>
                  </template>
                </b-table>
              </div>
            </div>
            <div class="spinner-wrapper" v-else>
              <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input :style="{width:'50px'}" @keyup.enter="page=pageInput" v-model="pageInput" type="text"
                           class="form-control">
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal size="lg" v-model="showModal" title="içerik ekle" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div
                v-if="formError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ formError }}</p>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="name">İçerik Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="İçerik Adı giriniz"
                    :class="{
        'is-invalid': addSubmitted && $v.addForm.name.$error,
      }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  İçerik Adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="type">İçerik Türü</label>
                <select
                    id="type"
                    v-model="addForm.type"
                    class="form-select"
                    :class="{
            'is-invalid': addSubmitted && $v.addForm.type.$error,
          }"
                >
                  <option value="" disabled>Seçiniz</option>
                  <option value="ders">Ders</option>
                  <option value="quiz">Quiz</option>
                </select>
                <div
                    v-if="addSubmitted && !$v.addForm.type.required"
                    class="invalid-feedback"
                >
                  İçerik Türü seçilmesi gereken bir alandır.
                </div>
              </div>
            </div>
            <div v-if="addForm.type === 'quiz'">
              <div class="col-6">
                <div class="mb-3">
                  <label for="question">Soru</label>
                  <textarea
                      id="question"
                      v-model="addForm.question"
                      class="form-control"
                      rows="4"
                      placeholder="Soru giriniz"
                      :class="{
              'is-invalid': addSubmitted && $v.addForm.question.$error,
            }"
                  ></textarea>
                  <div
                      v-if="addSubmitted && !$v.addForm.question.required"
                      class="invalid-feedback"
                  >
                    Soru girilmesi gereken bir alandır.
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="quizType">Tip</label>
                  <select
                      id="quizType"
                      v-model="addForm.quizType"
                      class="form-select"
                      :class="{
              'is-invalid': addSubmitted && $v.addForm.quizType.$error,
            }"
                  >
                    <option value="multipleChoice">Çoktan Seçmeli</option>
                    <option value="text">Text</option>
                  </select>
                  <div
                      v-if="addSubmitted && !$v.addForm.quizType.required"
                      class="invalid-feedback"
                  >
                    Tip seçilmesi gereken bir alandır.
                  </div>
                </div>
              </div>

              <div v-if="addForm.quizType === 'multipleChoice'" class="col-6">
                <div class="mb-3">
                  <label for="correctAnswer">Doğru Şık - Doğru Cevap</label>
                  <input
                      id="correctAnswer"
                      type="text"
                      v-model="addForm.correctAnswer"
                      class="form-control"
                      placeholder="Doğru cevap giriniz"
                      :class="{
              'is-invalid': addSubmitted && $v.addForm.correctAnswer.$error,
            }"
                  />
                  <div
                      v-if="addSubmitted && !$v.addForm.correctAnswer.required"
                      class="invalid-feedback"
                  >
                    Doğru cevap girilmesi gereken bir alandır.
                  </div>
                </div>
              </div>
            </div>
            <div v-if="addForm.type === 'multipleChoice'" class="col-12">
              <div class="mb-3">
                <label for="correctAnswer">Doğru Şık - Doğru Cevap</label>
                <input
                    id="correctAnswer"
                    type="text"
                    v-model="addForm.correctAnswer"
                    class="form-control"
                    placeholder="Doğru cevap giriniz"
                    :class="{
        'is-invalid': addSubmitted && $v.addForm.correctAnswer.$error,
      }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.correctAnswer.required"
                    class="invalid-feedback"
                >
                  Doğru cevap girilmesi gereken bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="addContentImage">Fotoğraf</label>
                <input
                    id="addContentImage"
                    type="file"
                    @change="handleContentImageUpload($event, addForm)"
                    accept="image/*"
                    class="form-control"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="videoUrl">Video Url</label>
                <input
                    id="videoUrl"
                    type="text"
                    v-model="addForm.videoUrl"
                    class="form-control"
                    placeholder="Video Url giriniz"
                    :class="{
        'is-invalid': addSubmitted && $v.addForm.videoUrl.$error,
      }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.videoUrl.required"
                    class="invalid-feedback"
                >
                  Video Url girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="addFile">Dosya (PDF veya Word)</label>
                <input
                    id="addFile"
                    type="file"
                    @change="handleFileUpload($event, addForm)"
                    accept=".pdf,.doc,.docx"
                    class="form-control"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="kurs">Kurs Seçiniz</label>
                <select v-model="addForm.kurs" class="form-select">
                  <option value="">Kurs Seçiniz</option>
                  <option v-for="course in courseData" :key="course.value" :value="course.value">{{ course.label }}</option>
                </select>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3 me-3 ">
                <label for="rates" class="me-2">Kurlar</label>
                <div class="checkbox-group me-2">
                  <label v-for="option in kurlar" :key="option.value">
                    <input
                        type="checkbox"
                        :value="option.value"
                        v-model="addForm.rates"
                        class="form-check-input ms-3"
                    />
                    {{ option.label }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <div class="">
                  <div class="mb-3">
                    <div class="scrollable">
                      <div v-for="rate in addForm.rates" :key="rate" class="mb-2">
                        <label>{{ rate }} Kuru İçin Fiyat Giriniz</label>
                        <div class="">
                          <input
                              id="numberInput"
                              class="form-control"
                              v-model="addForm.prices[rate]"
                              placeholder="Fiyat Giriniz"
                              @input="formatInput(rate)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <div  class="">
                  <div class="mb-3">
                    <div class="scrollable">
                      <div v-for="rate in addForm.rates" :key="rate" class="mb-2">
                        <label>{{ rate }} Kuru İçin Fiyat Giriniz</label>
                        <div class="">
                          <input
                              id="numberInput"
                              class="form-control"
                              v-model="addForm.prices[rate]"
                              placeholder="Fiyat Giriniz"
                              @input="formatInput(rate)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <div  class="">
                  <div class="mb-3">
                    <div class="scrollable">
                      <div v-for="rate in addForm.rates" :key="rate" class="mb-2">
                        <label>{{ rate }} Kuru İçin Fiyat Giriniz</label>
                        <div class="">
                          <input
                              id="numberInput"
                              class="form-control"
                              v-model="addForm.prices[rate]"
                              placeholder="Fiyat Giriniz"
                              @input="formatInput(rate)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="description">Açıklama</label>
                <quill-editor
                    v-model="addForm.description"
                    ref="quillEditor"
                    :options="quillOptions"
                ></quill-editor>
              </div>
            </div>


          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >içerik ekle
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal size="lg" v-model="editModal" title="içeriği düzenle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <label for="name">İçerik Adı</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="İçerik Adı giriniz"
                    :class="{
        'is-invalid': addSubmitted && $v.editForm.name.$error,
      }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  İçerik Adı girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="type">İçerik Türü</label>
                <select
                    id="type"
                    v-model="editForm.type"
                    class="form-select"
                    :class="{
            'is-invalid': addSubmitted && $v.editForm.type.$error,
          }"
                >
                  <option value="" disabled>Seçiniz</option>
                  <option value="ders">Ders</option>
                  <option value="quiz">Quiz</option>
                </select>
                <div
                    v-if="addSubmitted && !$v.editForm.type.required"
                    class="invalid-feedback"
                >
                  İçerik Türü seçilmesi gereken bir alandır.
                </div>
              </div>
            </div>
            <div v-if="editForm.type === 'quiz'">
              <div class="col-6">
                <div class="mb-3">
                  <label for="question">Soru</label>
                  <textarea
                      id="question"
                      v-model="editForm.question"
                      class="form-control"
                      rows="4"
                      placeholder="Soru giriniz"
                      :class="{
              'is-invalid': addSubmitted && $v.editForm.question.$error,
            }"
                  ></textarea>
                  <div
                      v-if="addSubmitted && !$v.editForm.question.required"
                      class="invalid-feedback"
                  >
                    Soru girilmesi gereken bir alandır.
                  </div>
                </div>
              </div>

              <div class="col-6">
                <div class="mb-3">
                  <label for="quizType">Tip</label>
                  <select
                      id="quizType"
                      v-model="editForm.quizType"
                      class="form-select"
                      :class="{
              'is-invalid': addSubmitted && $v.editForm.quizType.$error,
            }"
                  >
                    <option value="multipleChoice">Çoktan Seçmeli</option>
                    <option value="text">Text</option>
                  </select>
                  <div
                      v-if="addSubmitted && !$v.editForm.quizType.required"
                      class="invalid-feedback"
                  >
                    Tip seçilmesi gereken bir alandır.
                  </div>
                </div>
              </div>

              <div v-if="editForm.quizType === 'multipleChoice'" class="col-6">
                <div class="mb-3">
                  <label for="correctAnswer">Doğru Şık - Doğru Cevap</label>
                  <input
                      id="correctAnswer"
                      type="text"
                      v-model="editForm.correctAnswer"
                      class="form-control"
                      placeholder="Doğru cevap giriniz"
                      :class="{
              'is-invalid': addSubmitted && $v.editForm.correctAnswer.$error,
            }"
                  />
                  <div
                      v-if="addSubmitted && !$v.editForm.correctAnswer.required"
                      class="invalid-feedback"
                  >
                    Doğru cevap girilmesi gereken bir alandır.
                  </div>
                </div>
              </div>
            </div>
            <div v-if="editForm.type === 'multipleChoice'" class="col-12">
              <div class="mb-3">
                <label for="correctAnswer">Doğru Şık - Doğru Cevap</label>
                <input
                    id="correctAnswer"
                    type="text"
                    v-model="editForm.correctAnswer"
                    class="form-control"
                    placeholder="Doğru cevap giriniz"
                    :class="{
        'is-invalid': addSubmitted && $v.editForm.correctAnswer.$error,
      }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.correctAnswer.required"
                    class="invalid-feedback"
                >
                  Doğru cevap girilmesi gereken bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="image" class="form-label">Fotoğraf</label>
                <input
                    type="file"
                    id="image"
                    @change="onEditImageChange"
                    accept="image/*"
                    class="form-control"
                />
                <input
                    disabled
                    type="text"
                    id="image"
                    @change="onEditImageChange"
                    :value="editForm.image"
                    accept="image/*"
                    class="form-control mt-2"
                />
                <div v-if="editForm.image" class="mt-2 text-center">
                  <img :src="editForm.image" alt="Mevcut Resim" style="max-width: 50%; max-height: 100px;"/>
                </div>
              </div>


            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="videoUrl">Video Url</label>
                <input
                    id="videoUrl"
                    type="text"
                    v-model="editForm.videoUrl"
                    class="form-control"
                    placeholder="Video Url giriniz"
                    :class="{
        'is-invalid': addSubmitted && $v.editForm.videoUrl.$error,
      }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.videoUrl.required"
                    class="invalid-feedback"
                >
                  Video Url girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="addFile">Dosya (PDF veya Word)</label>
                <input
                    id="addFile"
                    type="file"
                    @change="handleFileUpload($event, editForm)"
                    accept=".pdf,.doc,.docx"
                    class="form-control"
                />
              </div>
            </div>
            <div class="col-6">
              <div class="mb-3">
                <label for="kurs">Kurs Seçiniz</label>
                <select v-model="editForm.kurs" class="form-select">
                  <option value="">Kurs Seçiniz</option>
                  <option v-for="course in courseData" :key="course.value" :value="course.value">{{ course.label }}</option>
                </select>
              </div>
            </div>

            <div class="col-12">
              <div class="mb-3">
                <div class="">
                  <div class="mb-3">
                    <div class="scrollable">
                      <div v-for="rate in editForm.rates" :key="rate" class="mb-2">
                        <label>{{ rate }} Kuru İçin Fiyat Giriniz</label>
                        <div class="">
                          <input
                              id="numberInput"
                              class="form-control"
                              v-model="editForm.prices[rate]"
                              placeholder="Fiyat Giriniz"
                              @input="formatInput(rate)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <div  class="">
                  <div class="mb-3">
                    <div class="scrollable">
                      <div v-for="rate in editForm.rates" :key="rate" class="mb-2">
                        <label>{{ rate }} Kuru İçin Fiyat Giriniz</label>
                        <div class="">
                          <input
                              id="numberInput"
                              class="form-control"
                              v-model="editForm.prices[rate]"
                              placeholder="Fiyat Giriniz"
                              @input="formatInput(rate)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>








            <div class="col-6">
              <div class="mb-3">
                <div  class="">
                  <div class="mb-3">
                    <div class="scrollable">
                      <div v-for="rate in editForm.rates" :key="rate" class="mb-2">
                        <label>{{ rate }} Kuru İçin Fiyat Giriniz</label>
                        <div class="">
                          <input
                              id="numberInput"
                              class="form-control"
                              v-model="editForm.prices[rate]"
                              placeholder="Fiyat Giriniz"
                              @input="formatInput(rate)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="description">Açıklama</label>
                <quill-editor
                    v-model="editForm.description"
                    ref="quillEditor"
                    :options="quillOptions"
                ></quill-editor>
              </div>
            </div>

            <div
                v-if="editFormError.length>0"
                class="text-danger d-flex justify-content-end"
            >
              <p>{{ editFormError }}</p>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >içeriği düzenle
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu contentyi silmek istediğinize emin misiniz? Silinmiş contentyi geri alamazsınız.
              </p>
              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız contentyi silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}
.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
